// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__KFu_q","resendInfoText":"OnGoingPaymentBox_resendInfoText__1ZL7o"};